import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-parallelogram",
  "use": "icon-th-parallelogram-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-parallelogram\">\n<path d=\"M30.6787 5.91375C30.4979 5.63296 30.2494 5.40211 29.9561 5.24245C29.6627 5.08278 29.334 4.99941 29 5H11.1012C10.716 4.99998 10.339 5.1112 10.0155 5.32031C9.69193 5.52941 9.43567 5.82751 9.27749 6.17875L1.17749 24.1788C1.04036 24.4833 0.98166 24.8173 1.00675 25.1503C1.03184 25.4833 1.13993 25.8047 1.32114 26.0852C1.50235 26.3658 1.75093 26.5964 2.04418 26.7562C2.33743 26.916 2.66603 26.9998 2.99999 27H20.8987C21.284 27 21.661 26.8888 21.9845 26.6797C22.3081 26.4706 22.5643 26.1725 22.7225 25.8213L30.8225 7.82125C30.9598 7.51661 31.0186 7.18241 30.9935 6.8492C30.9683 6.51599 30.8601 6.19438 30.6787 5.91375ZM20.8987 25H2.99999L11.1012 7H29L20.8987 25Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-parallelogram.svg
// module id = z7ac
// module chunks = 84